<template>
  <PartTag
    :items="assemblies"
    :recent-selected-tags="recentSelectedTags(LabelTaggingMode.PART)"
    :selected-part-name="selectedPartName"
    :collapse="collapse(LabelTaggingMode.PART)"
    @onPartTagSelected="handlePartTagSelected"
    @onRecentTagSelected="handlePartTagSelected"
    @onToggleCollapse="handleToggleCollapse"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { LabelTaggingMode } from '@/utils';
import PartTag from './PartTag.vue';

export default {
  name: 'PartTagContainer',
  components: {
    PartTag,
  },
  props: {
    selectedPolygon: {
      type: Object,
      default: () => ({}),
    },
    selectedPart: {
      type: Object,
      default: () => ({}),
    },
    polygon: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      LabelTaggingMode,
      selectedPartName: this.selectedPart?.name,
    };
  },
  computed: mapGetters({
    inspectionDocument: 'inspectionDocument/currentInspectionInfo',
    assemblies: 'labelTagging/assemblies',
    recentSelectedTags: 'labelTagging/recentSelectedTags',
    collapse: 'labelTagging/collapse',
  }),
  watch: {
    selectedPart({ name }) {
      this.selectedPartName = name;
    },
  },
  created() {
    if (!this.assemblies) {
      this.loadAssemblies(this.$route.query.id);
    }
  },
  methods: {
    ...mapActions({
      loadAssemblies: 'labelTagging/loadAssemblies',
      addToRecentSelectedTags: 'labelTagging/addToRecentSelectedTags',
      updatePartAssembly: 'inspectionDocument/updatePartAssembly',
      toggleCollapsed: 'labelTagging/toggleCollapsed',
    }),
    async handlePartTagSelected(partTag) {
      this.addToRecentSelectedTags({ taggingMode: LabelTaggingMode.PART, tag: partTag });
      this.updatePartAssembly({
        platformId: this.inspectionDocument._id,
        equipmentId: this.selectedPolygon.equipmentId,
        assemblyId: partTag.tagId,
        assemblyName: partTag.tagName,
      });

      this.selectedPartName = partTag.tagName;
    },
    handleToggleCollapse() {
      this.toggleCollapsed(LabelTaggingMode.PART);
    },
  },
};
</script>
